/**
 * @file v-copy directive
 * @fuqiang15
 */

function copyToClipboard(text) {
    let ele = document.createElement('textarea');
    ele.style.fontSize = '12pt';
    ele.style.position = 'absolute';
    ele.style.left = '-9999px';
    ele.style.top = '0';
    ele.setAttribute('readonly', '');
    ele.value = text;
    document.body.appendChild(ele);
    ele.select();
    let result = document.execCommand('copy');
    document.body.removeChild(ele);
    return result;
}

export default function genCopy() {
    // v-copy:click="'text'"
    // TODO 支持组件
    let text = '';
    let eventName = null;
    const handler = event => {
        return copyToClipboard(text);
    };
    return {
        inserted(el, binding) {
            eventName = binding.arg || 'click';
            text = binding.value;
            el.addEventListener(eventName, handler);
        },
        update(el, binding) {
            text = binding.value;
        },
        unbind(el) {
            el.removeEventListener(eventName, handler);
        }
    };
}
